(function () {
  function switchGallery(thumb) {
    var gallery = thumb.closest("[data-ba-gallery]");
    if (!gallery) return;

    var thumbs = gallery.querySelectorAll("[data-ba-thumb]");
    var media = gallery.querySelectorAll("[data-ba-media]");
    if (!thumbs.length || !media.length) return;

    var index = thumb.getAttribute("data-ba-thumb");

    thumbs.forEach(function (item) {
      item.classList.toggle("is-active", item === thumb);
    });

    media.forEach(function (item) {
      var active = item.getAttribute("data-ba-media") === index;
      item.classList.toggle("is-active", active);

      var video = item.querySelector("video");
      if (video && !active) video.pause();
    });
  }

  function initVariantForms(root) {
    root.querySelectorAll("[data-ba-product-form]").forEach(function (form) {
      var select = form.querySelector("[data-ba-variant-select]");
      var idInput = form.querySelector('input[name="id"]');
      var priceTarget = document.querySelector("[data-ba-product-price]");
      var compareTarget = document.querySelector("[data-ba-product-compare]");
      var discountTarget = document.querySelector("[data-ba-product-discount]");

      if (!select || !idInput) return;

      select.addEventListener("change", function () {
        var option = select.options[select.selectedIndex];
        idInput.value = option.value;

        if (priceTarget && option.dataset.price) priceTarget.textContent = option.dataset.price;
        if (compareTarget) compareTarget.textContent = option.dataset.compare || "";
        if (discountTarget) discountTarget.textContent = option.dataset.discount || "";
      });
    });
  }

  function setButtonLoading(button, isLoading) {
    if (!button) return;

    if (isLoading) {
      button.dataset.originalText = button.textContent;
      button.textContent = "Adding...";
      button.disabled = true;
    } else {
      button.textContent = button.dataset.originalText || "Buy now";
      button.disabled = false;
    }
  }

  function handleBuyNow(button) {
    var wrapper = button.closest("[data-ba-product-form]");
    var form = wrapper && wrapper.querySelector("form");
    if (!form) return;

    setButtonLoading(button, true);

    if (window.halo && typeof window.halo.actionAddToCart2 === "function" && window.jQuery) {
      window.halo.actionAddToCart2(window.jQuery(button), window.jQuery(form));
      window.setTimeout(function () {
        setButtonLoading(button, false);
      }, 1800);
      return;
    }

    form.setAttribute("action", "/cart/add");
    form.submit();
  }

  function initBaCartForms(root) {
    root.querySelectorAll("[data-ba-product-form] form").forEach(function (form) {
      if (form.dataset.baCartFormReady === "true") return;

      form.dataset.baCartFormReady = "true";
      form.addEventListener("submit", function (event) {
        var submitter = event.submitter || document.activeElement;
        if (submitter && submitter.matches("[data-ba-buy-now]")) return;

        if (!(window.halo && typeof window.halo.actionAddToCart2 === "function" && window.jQuery)) return;

        event.preventDefault();
        window.halo.actionAddToCart2(window.jQuery(submitter || form.querySelector('[name="add"]')), window.jQuery(form));
      });
    });
  }

  function initVideoCards(root) {
    root.querySelectorAll("[data-ba-video-toggle]").forEach(function (button) {
      button.addEventListener("click", function () {
        var card = button.closest("[data-ba-video-card]");
        var video = card && card.querySelector("video");
        if (!video) return;

        if (video.paused) {
          video.play();
          button.textContent = "Pause";
        } else {
          video.pause();
          button.textContent = "Play";
        }
      });
    });
  }

  function initSmoothDetails(root) {
    root.querySelectorAll("[data-ba-smooth-details]").forEach(function (details) {
      if (details.dataset.baSmoothReady === "true") return;

      var summary = details.querySelector("summary");
      var content = details.querySelector(".ba-product-details__content");
      if (!summary || !content) return;

      details.dataset.baSmoothReady = "true";
      content.style.height = details.open ? content.scrollHeight + "px" : "0px";
      content.style.opacity = details.open ? "1" : "0";

      summary.addEventListener("click", function (event) {
        event.preventDefault();
        var isOpen = details.open;

        if (isOpen) {
          content.style.height = content.scrollHeight + "px";
          requestAnimationFrame(function () {
            content.style.height = "0px";
            content.style.opacity = "0";
          });

          window.setTimeout(function () {
            details.open = false;
          }, 260);
        } else {
          details.open = true;
          content.style.height = "0px";
          content.style.opacity = "0";

          requestAnimationFrame(function () {
            content.style.height = content.scrollHeight + "px";
            content.style.opacity = "1";
          });
        }
      });

      content.addEventListener("transitionend", function (event) {
        if (event.propertyName !== "height" || !details.open) return;
        content.style.height = "auto";
      });

      details.querySelectorAll(".ba-product-details__radio").forEach(function (radio) {
        radio.addEventListener("change", function () {
          if (!details.open) return;
          content.style.height = content.scrollHeight + "px";
          requestAnimationFrame(function () {
            content.style.height = content.scrollHeight + "px";
          });
        });
      });
    });
  }

  function init(root) {
    initVariantForms(root);
    initBaCartForms(root);
    initVideoCards(root);
    initSmoothDetails(root);
  }

  document.addEventListener("click", function (event) {
    var buyNowButton = event.target.closest("[data-ba-buy-now]");
    if (buyNowButton) {
      event.preventDefault();
      handleBuyNow(buyNowButton);
      return;
    }

    var thumb = event.target.closest("[data-ba-thumb]");
    if (!thumb) return;

    event.preventDefault();
    switchGallery(thumb);
  });

  document.addEventListener("mouseover", function (event) {
    var thumb = event.target.closest("[data-ba-thumb]");
    if (thumb) switchGallery(thumb);
  });

  document.addEventListener("focusin", function (event) {
    var thumb = event.target.closest("[data-ba-thumb]");
    if (thumb) switchGallery(thumb);
  });

  document.addEventListener("DOMContentLoaded", function () {
    init(document);
  });

  document.addEventListener("shopify:section:load", function (event) {
    init(event.target);
  });
})();
